import {
  InMemoryHeader,
  InMemoryString,
  InMemoryDate,
  InMemoryDecimal,
} from "pbas-vue-components";

const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2
});

const headers =  [
  new InMemoryHeader({
    title: "headers.claims_payments.BatchNumber",
    type: new InMemoryString("BatchNumber"),
    sortable: true,
    visible: true,
    searchable: true
  }),
  new InMemoryHeader({
    title: "views.planbalance.cheque_number",
    type: new InMemoryString("PaymentNumber"),
    sortable: true,
    visible: true,
    searchable: true,
    isIdentifier: true,
  }),
  new InMemoryHeader({
    title: "components.chequerequisitionform.payee",
    type: new InMemoryString("Payee"),
    sortable: true,
    visible: true,
    searchable: true
  }),
  new InMemoryHeader({
    title: "headers.claims_payments.Payee",
    type: new InMemoryString("PayeeType"),
    sortable: true,
    visible: true,
    searchable: true
  }),
  new InMemoryHeader({
    title: "components.expenses_table.paid_amount",
    type: new InMemoryDecimal("PaidAmount", {
      getString: (item) => {
        const value = item.PaidAmount;
        if (value === null || value === undefined) {
          return "";
        }
        if (typeof value !== "number") {
          return value;
        }
        return formatter.format(value);
      },
    }),
    sortable: true,
    visible: true,
    searchable: true
  }),
  new InMemoryHeader({
    title: "headers.claims_payments.CancelledAt",
    type: new InMemoryDate("CancelledAt"),
    sortable: true,
    visible: true,
    searchable: true,
    allowVisibilityChange: true,
  }),
];

function getHeaders() {
  return headers;
}

export default getHeaders